
module.exports = require('../../../config/runtime/boring-config');
